var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_157_3919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.24875 13.9038L8.5 16.9045L11.7512 13.9038L12.75 14.8276L8.5 18.7586L4.25 14.8276L5.24875 13.9038Z",
    fill: "#8A8E9F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_157_3919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.24875 10.0962L8.5 7.0955L11.7512 10.0962L12.75 9.1724L8.5 5.24136L4.25 9.1724L5.24875 10.0962Z",
    fill: "#8A8E9F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_157_3919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 15.7241,
    fill: "white",
    transform: "translate(0 8.27588)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_157_3919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 15.7241,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 15.7241)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.6b77c4245b697feeef559abe87e9b1e6.svg";
export { ForwardRef as ReactComponent };